<template>
  <div class="page" v-wechat-title="$route.meta.title='推广'">

    <img class="extend-bj" src="../../assets/extend_01.jpg" alt="">

    <div class="extend-main border-box">
      <p class="extend-tab clearfix">
        <span :class="loginWay==1?'curr':''" @click="loginWay=1">申请赚钱</span>
        <span :class="loginWay==0?'curr':''" @click="loginWay=0">直接登录</span>

      </p>

      <div class="extend-cont">
        <div class="extend-box" v-if="loginWay == 1" style="margin-top: -.39rem;">
          <img src="../../assets/extend_icon05.png" alt="">
          <input placeholder="请输入您的姓名" v-model="extendName" />
        </div>
        <div class="extend-box">
          <img src="../../assets/extend_icon01.png" alt="">
          <input type="tel" placeholder="请输入您的手机号码" v-model="extendTel" />
        </div>
        <div class="extend-box extend-yzm clearfix">
          <img src="../../assets/extend_icon02.png" alt="">
          <input type="tel" placeholder="请输入手机验证码" v-model="extendYzm" />
          <span :class="yzmSend==1?'disabled':''" @click="getYzm">{{yzmTxt}}</span>
        </div>
        <div class="extend-box" v-if="loginWay == 1">
          <img src="../../assets/extend_icon03.png" alt="">
          <input type="tel" placeholder="推广邀请码" v-model="extendYqm" />
        </div>
      </div>
      <div class="extend-text" v-if="loginWay == 1" @click="goArticle">! 如何获取邀请码 !</div>
    </div>

    <div class="extend-btn" v-if="loginWay==0" @click="login">登录</div>
    <div class="extend-btn" v-if="loginWay==1" @click="login">申请</div>

  </div>

</template>

<script>
  import axios from 'axios'
  import Qs from 'qs'
  import {getServer} from '@/utils/share'
  import {setStore, getStore, removeStore} from '@/config/mUtils'
  import {getTelYzm,getIsRegister} from "@/service/getData";
  import wxConfirm from '@/wechat-messagebox/Confirm'
  import D from '@/wc-messagebox'
  import Vue from 'vue'
  Vue.use(D)

  export default {
    data(){
      return{
        TimeStamp: new Date().getTime(),  //获取当前时间
        userInfo: {},
        loginWay: 0, //0：登录  1：注册
        extendName: '',
        extendTel: '',
        extendYzm: '',
        extendYqm: '',
        yzmTxt: '发送验证码',
        yzmSend: 0, //0：未发送 1：已发送
        count: 59, //倒计时
        timer: null, //计时器
      }
    },
    computed: {

    },
    created() {
      this.initData();

      this.userInfo = getStore("userInfo");

    },
    beforeDestroy(){
      window.removeEventListener("scroll", function () {});
      if (this.timer) {
        clearInterval(this.timer);
      }
    },
    methods: {
      async initData(){
        //判断是否注册
        let res = await getIsRegister({
          openid: getStore("userInfo").openid
        });
        if (res.errcode == '00000') {
          if(res.data == true){
            this.loginWay = 0;

            let user = getStore("user",1) || "";
            if(user && user.user != '' && user.user != null && user.user != undefined){
              this.id = user.user;

              this.$router.replace({
                path: `/extend-center?${'id='+this.id}`
              });
            }
          }else{
            this.loginWay = 1
          }
        }
      },


      //登录
      login(){
        let self = this;

        if (self.loginWay == 1 && (self.extendName == undefined || self.extendName == '' || self.extendName == null)) {
          self.$toast('请输入您的姓名')
          return
        }

        if (self.extendTel == undefined || self.extendTel == '' || self.extendTel == null) {
          self.$toast('请输入您的手机号码')
          return
        }
        if (!(/^1[23456789]\d{9}$/.test(self.extendTel))) {
          self.$toast('手机号码格式不正确')
          return
        }
        if (self.extendYzm == undefined || self.extendYzm == '' || self.extendYzm == null) {
          self.$toast('请输入手机验证码')
          return
        }

        self.userInfo = getStore("userInfo");
        let url = "", obj = {};
        if(self.loginWay != 1){
          url = "authChannel/login.do";
          obj = {
            phone: self.extendTel,
            code: self.extendYzm,
            openid: self.userInfo.openid
          }
        }else {
          url = "authChannel/apply.do";
          obj = {
            name: self.extendName,
            phone: self.extendTel,
            code: self.extendYzm,
            openid: self.userInfo.openid,
            invite: self.extendYqm
          }
        }

        axios.post( getServer().admin + url, Qs.stringify(obj), {
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
          }
        }).then(function (data) {
          console.log(data);
          if(data.data.errcode == "00000"){
            setStore("user", {"user":data.data.data},1);
            self.$router.replace({
              path: `/extend-center?${'id='+data.data.data}`
            });
          }else {
            self.$toast(data.data.errmsg);
          }
        })

      },

      //获取手机验证码
      async getYzm(){
        let self = this;

        if(self.yzmSend == 1){
          return;
        }

        if (self.extendTel == undefined || self.extendTel == '' || self.extendTel == null) {
          self.$toast('请输入您的手机号码')
          return
        }
        if (!(/^1[23456789]\d{9}$/.test(self.extendTel))) {
          self.$toast('手机号码格式不正确')
          return
        }

        let res = await getTelYzm({
          TimeStamp: self.TimeStamp,
          phone: self.extendTel
        });
        console.log(res);
        if(res.errcode == "00000"){
          self.$toast('发送成功请稍等');
          self.yzmSend = 1;

          self.timer = setInterval(self.CountDown, 1000);
        }

      },

      CountDown(){
        this.yzmTxt = "重新发送(" + this.count + ")";
        if (this.count<= 0) {
          clearInterval(this.timer);
          this.yzmSend = 0;
          this.yzmTxt = "获取验证码";
        }
        this.count--;
      },
      //邀请码须知
      goArticle(){
        this.$router.push({
          path: `/extend-article`
        });
      },

    },
    components: {

    },

  }

</script>

<style scoped>

  .page{ position: relative; width: 100%;height: 100vh; background: #fff; }
  .extend-bj{ position: relative; width: 100%; height: auto;  background-size: 100% auto; }
  .extend-main{position: relative;margin: -1.69rem auto 0;width: 79%;border-radius: .2rem;  }
  .extend-tab{ width: 100%;height: .97rem ;background-color: #fff;border-radius: .16rem;}
  .extend-tab span{ float: left;position: relative; width: 50%; height: .97rem; font: .28rem/.97rem "Microsoft YaHei"; color: #cacaca; text-align: center; }
  .extend-tab span:first-child:after{content: '';position: absolute;top:.26rem;bottom:.26rem;right:-.015rem;width:.03rem;background: #cfcfcf;}
  .extend-tab span.curr{ color: #f7921e; border-bottom-color:#f7921e; }
  .extend-cont{ padding: .76rem .5rem;margin-top: .13rem;background-color: #fff;border-radius: .16rem;-webkit-box-shadow: 0 20px 35px #fff8ee;box-shadow: 0 20px 35px #fff8ee;}
  .extend-box{ position: relative; padding: .18rem .1rem .18rem .7rem; height: .37rem; margin-top:.36rem;font: .22rem/.36rem "Microsoft YaHei"; color: #333; border-bottom: 1px solid #d7d7d7; }
  .extend-box:first-child{margin-top: 0;}
  .extend-box img{ position: absolute; left: .07rem; top: 50%; width: .29rem; height: auto; transform: translateY(-50%); }
  .extend-box input{ position: relative; display: block; width: 100%; height: .36rem;;ine-height: .36rem; font-size: .28rem; border-radius: 0; }
  .extend-yzm input{ float: left; width: 60%; height: .36rem;;ine-height: .36rem; border-right: 2px solid #d7d7d7; }
  .extend-yzm span{ float: right; width: 38%; color: #f7921e; text-align: center; }
  .extend-yzm span.disabled{ color: #cacaca; }
  .extend-btn{ position:relative;width: 80%;height: .8rem;margin: .5rem auto 0; font: .3rem/.8rem "Microsoft YaHei";color: #fff;text-align: center;border-radius: .6rem; background-color: #f7921e; }
  .extend-text{margin-top:.27rem;text-align: center;font-size: .2rem;color: #d71e0b;text-decoration: underline;}
</style>



// WEBPACK FOOTER //
// src/page/extend-login/extend-login.vue